import { render } from "./PlaneWithTickIcon.vue?vue&type=template&id=65e0dbf5"
import script from "./PlaneWithTickIcon.vue?vue&type=script&lang=js"
export * from "./PlaneWithTickIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__